const myUrl = window.location.origin || document.referrer
const url = 'https://aquaparc.aquasys.fr'

const usedUrl = myUrl.includes('localhost') ? url : myUrl

const pathApi = `${usedUrl}${usedUrl.endsWith('/') ? '' : '/'}api`

export { pathApi, myUrl, usedUrl }
